// Errores Api
export const SHOW_ERRORS_API = "SHOW_ERRORS_API";
// Auth
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";

// Categories
export const GET_ALL_CATEGORIAS = "GET_ALL_CATEGORIAS";
export const ADD_CATEGORIAS = "ADD_CATEGORIAS";
export const UPDATE_CATEGORIAS = "UPDATE_CATEGORIAS";
export const DELETE_CATEGORIAS = "DELETE_CATEGORIAS";

// Subcategories
export const GET_ALL_SUBCATEGORIAS = "GET_ALL_SUBCATEGORIAS";
export const ADD_SUBCATEGORIAS = "ADD_SUBCATEGORIAS";
export const UPDATE_SUBCATEGORIAS = "UPDATE_SUBCATEGORIAS";
export const DELETE_SUBCATEGORIAS = "DELETE_SUBCATEGORIAS";

// Segmentos
export const GET_ALL_SEGMENTOS = "GET_ALL_SEGMENTOS";
export const ADD_SEGMENTOS = "ADD_SEGMENTOS";
export const UPDATE_SEGMENTOS = "UPDATE_SEGMENTOS";
export const DELETE_SEGMENTOS = "DELETE_SEGMENTOS";

// Modelos
export const GET_ALL_MODELOS = "GET_ALL_MODELOS";
export const ADD_MODELOS = "ADD_MODELOS";
export const UPDATE_MODELOS = "UPDATE_MODELOS";
export const DELETE_MODELOS = "DELETE_MODELOS";

//Fichas Tecnicas
export const GET_ALL_FICHAS_TECNICAS = "GET_ALL_FICHAS_TECNICAS";
export const ADD_FICHAS_TECNICAS = "ADD_FICHAS_TECNICAS";
export const UPDATE_FICHAS_TECNICAS = "UPDATE_FICHAS_TECNICAS";
export const DELETE_FICHAS_TECNICAS = "DELETE_FICHAS_TECNICAS";

//Fichas Tecnicas en Desarrollo
export const GET_ALL_FICHAS_TECNICAS_DESARROLLO = "GET_ALL_FICHAS_TECNICAS_DESARROLLO";
export const ADD_FICHAS_TECNICAS_DESARROLLO = "ADD_FICHAS_TECNICAS_DESARROLLO";
export const UPDATE_FICHAS_TECNICAS_DESARROLLO = "UPDATE_FICHAS_TECNICAS_DESARROLLO";
export const DELETE_FICHAS_TECNICAS_DESARROLLO = "DELETE_FICHAS_TECNICAS_DESARROLLO";

export const CERRAR_SESION = "CERRAR_SESION";
